import { render, staticRenderFns } from "./AutoSuggestBasic.vue?vue&type=template&id=5823dda2"
import script from "./AutoSuggestBasic.vue?vue&type=script&lang=js"
export * from "./AutoSuggestBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports